import {Box} from "@mui/material";
import React, {useEffect, useRef, useState} from "react";
import {useTemplate} from "../../context/TemplateContext";
import {useMobile} from "../../context/MobileContext";
import {TextInput} from "../../models/Template";
import {useTranslation} from "react-i18next";

const ContentEditableInfoBar: React.FC = ({}) => {
    const {template, selectedContentEditable} = useTemplate();
    const {isMobile} = useMobile()
    const [text, setText] = useState<string | null>(null)
    const inputRef = useRef<HTMLElement>(null); // Ref for the input
    const [top, setTop] = useState<string | null>(null)
    const {t} = useTranslation()

    useEffect(() => {
        if (!selectedContentEditable) return;

        const input = template?.inputs?.[selectedContentEditable!] as TextInput
        if (input) {
            setText(t("editor.tooltip.maxChars", {input}))
        }

    }, [selectedContentEditable])


    useEffect(() => {
        const handleScroll = () => {
            if (isMobile && inputRef.current) {
                const scrolledY = window.scrollY;
                inputRef.current.style.top = `${scrolledY}px`; // Set top to current scroll position
            }
        };

        // Attach scroll event listener
        window.addEventListener('scroll', handleScroll);

        // Clean up function
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        if (!isMobile) {
            const topBar = document.querySelector<HTMLElement>(".MuiAppBar-root")
            if (topBar) {
                setTop(`${topBar.offsetHeight + 16}px`)
            }
        }
    }, [isMobile])

    return <Box ref={inputRef} p={2} sx={{
        visibility: !!selectedContentEditable ? "visible" : 'hidden',
        minWidth: "200px",
        position: "absolute",
        right: isMobile ? 0 : "16px",
        left: isMobile ? 0 : "unset",
        top,
        height: "auto",
        backgroundImage: isMobile ? "linear-gradient(192deg, #05101D 58.35%, rgba(0, 161, 225, 1) 138%)" :
            "linear-gradient(192deg, #05101D 35.35%, rgba(0, 161, 225, 1) 138%)",
        color: "white",
        fontSize: "19px",
        borderRadius: isMobile ? 0 : "10px",
        zIndex: 100000
    }}>{text}</Box>;
}

export default ContentEditableInfoBar;